import type { BaseContentProps } from "./types";

export const DecorContent = ({ content }: BaseContentProps) => {
  if (!content.media) {
    return null;
  }

  return (
    <img
      src={content.media.url}
      style={{
        width: "100%",
        height: 100,
        minHeight: 100,
        objectFit: "contain",
        position: "relative",
      }}
      alt=""
    />
  );
};
